import LearningPathTrainingsTab from "~/components/Pages/learning-path/component/trainings/TrainingsTab.vue";
import LearningPathGeneralTab from "~/components/Pages/learning-path/component/trainings/GeneralTab.vue";

import { useLearningPathAttendeesStore } from "~/store/learning-path/learning-path-attendees.store";
import { useLearningPathStore } from "~/store/learning-path/learning-path.store";
import { LearningPathNavEnum, LearningPathTabTypeEnum } from "~/utils/enums/learning-path.enums";
import type { IHeaderNav, IIndexHeader } from "~/utils/interfaces/table-interfaces";
import type { ILearningPath } from "~/utils/interfaces/learning-path-interfaces";

export const useLearningPath = () => {
  const {
    editLearningPath,
    handleLearningPathArchivedModal,
    handleLearningPathDeleteUnauthorizedModal,
    duplicateLearningPath,
  } = useLearningPathStore();
  const { handleLearningPathAddAttendeesModal, setCurrentLearningPathId } = useLearningPathAttendeesStore();
  const { hasAttendees, form, learningPathIdToArchive } = storeToRefs(useLearningPathStore());
  const headers = useState<IIndexHeader[]>(() => [
    {
      name: "Nom",
      key: "name",
      sort: true,
      minWidthPx: 600,
      maxWidthFr: 1,
      visible: true,
    },
    {
      name: "Formations",
      key: "nb_trainings",
      sort: true,
      minWidthPx: 80,
      maxWidthFr: 1,
      visible: true,
    },
    {
      name: "Participants",
      key: "nb_attendees",
      sort: true,
      minWidthPx: 80,
      maxWidthFr: 1,
      visible: true,
    },
    {
      name: "",
      key: "actions",
      sort: false,
      minWidthPx: 60,
      maxWidthFr: 1,
      visible: true,
    },
  ]);

  function getNav(): IHeaderNav[] {
    return [];
  }

  function getLearningPathNav(): IHeaderNav[] {
    const nav = [
      {
        name: LearningPathNavEnum.GENERAL,
        type: LearningPathTabTypeEnum.GENERAL,
        component: LearningPathGeneralTab,
      },
      {
        name: LearningPathNavEnum.TRAININGS,
        type: LearningPathTabTypeEnum.TRAININGS,
        component: LearningPathTrainingsTab,
      },
    ];

    return nav;
  }

  function findLearningPathNav(type: LearningPathTabTypeEnum) {
    return getLearningPathNav().find((nav) => nav.type === type);
  }

  const addPanel = (row: ILearningPath) => [
    {
      name: "Ajouter des participants",
      icon: "invite",
      function: () => {
        setCurrentLearningPathId(row.learningPathId);
        handleLearningPathAddAttendeesModal(true);
      },
    },
    {
      name: "Modifier",
      icon: "edit",
      function: () => editLearningPath(row.learningPathId, row.nbAttendees > 0),
    },
    {
      name: "Dupliquer",
      icon: "duplicate",
      function: () => duplicateLearningPath(row.learningPathId),
    },
    {
      name: "Archiver",
      icon: "delete_trash",
      function: () => {
        handleLearningPathArchivedModal(true);
        learningPathIdToArchive.value = row.learningPathId;
      },
    },
  ];

  const cardPanel = [
    {
      name: "Supprimer",
      icon: "delete_trash",
      function: (index: number) => {
        if (hasAttendees.value) {
          handleLearningPathDeleteUnauthorizedModal(true);
          return;
        }

        form.value.trainings = form.value.trainings.filter((_, i) => i !== index);
      },
    },
  ];

  return {
    headers,
    getNav,
    addPanel,
    cardPanel,
    getLearningPathNav,
    findLearningPathNav,
  };
};
